import * as React from "react";
import styled from "styled-components";
import { FaStickyNote } from "react-icons/fa";

const Badge = styled.span<{ $compact?: boolean }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	color: #b45309;
	background: #fef3c7;
	border: 1px solid #fcd34d;
	border-radius: ${({ $compact }) => ($compact ? 6 : 8)}px;
	padding: ${({ $compact }) => ($compact ? "2px 5px" : "3px 7px")};
	line-height: 1;
	box-shadow: 0 1px 2px rgba(180, 83, 9, 0.12);

	svg {
		width: ${({ $compact }) => ($compact ? 11 : 13)}px;
		height: ${({ $compact }) => ($compact ? 11 : 13)}px;
	}
`;

type Props = {
	notes?: string | null;
	compact?: boolean;
	className?: string;
	style?: React.CSSProperties;
};

/** Visible when guest or staff left booking notes (not the subtle dot on Notes action). */
export function BookingNotesIndicator({ notes, compact, className, style }: Props) {
	const text = notes?.trim();
	if (!text) return null;
	const preview = text.length > 120 ? `${text.slice(0, 117)}…` : text;
	return (
		<Badge
			$compact={compact}
			className={className}
			style={style}
			title={preview}
			aria-label="Guest notes on this booking"
		>
			<FaStickyNote aria-hidden />
		</Badge>
	);
}
